/**
 * Multi-host scheduling-type check and host-identity-suppression decision.
 *
 * Collective and round_robin meeting types have no single visible owner —
 * collective bookings include everyone, round_robin picks someone at
 * booking-time — so booking surfaces suppress the host avatar/name for
 * those types. Shared here so the rule lives in exactly one place.
 */

/**
 * Whether a scheduling type has more than one possible host.
 *
 * @param schedulingType - The meeting type's `scheduling_type` value.
 * @returns True when `schedulingType` is `'collective'` or `'round_robin'`.
 */
export function isMultiHostSchedulingType(
  schedulingType: string | undefined
): boolean {
  return schedulingType === 'collective' || schedulingType === 'round_robin';
}

/**
 * Whether a booking surface should render the host's identity (avatar/name).
 *
 * @param meetingType - Object exposing `scheduling_type` and `hide_host_info`.
 * @returns True unless the meeting type is multi-host or has host info hidden.
 */
export function shouldShowHostIdentity(meetingType: {
  scheduling_type?: string;
  hide_host_info?: boolean;
}): boolean {
  return (
    !isMultiHostSchedulingType(meetingType.scheduling_type) &&
    !meetingType.hide_host_info
  );
}
